import React from "react";
import Icons from "../../../../util/Icons";
import Context from "../../../../../context/Context";
import CheckCircleIcon from "calcite-ui-icons-react/CheckCircleIcon"
import Button from "calcite-react/Button";
import { downloadICSFile, getBookingSystemType } from "./WorkspaceReservation/workspaceReservationUtil";
import { makeEventInfo } from "../../../../../util/calendarUtil";
import CalendarSelector from "../../../../../util/CalendarSelector";

const CSS = {
    popoutInner: "i-popout-inner i-booking-confirmed-popup",
    popoutOuter: "i-popout-outer",
    panelHeader: "i-infopanel-header i-panel-header",
    panelHeaderTools: "i-panel-header-tools",
    filterForm: "i-filter-form",
    toggleAllDay: "i-toggle-all-day",
    toggleLabel: "i-toggle-label",
    durationFilter: "i-duration-filter",
    durationFilterForm: "i-duration-filter-form",
    durationGroup: "i-duration-group",
    durationDate: "i-date",
    durationTime: "i-time",
    iconContainer: "i-sidebar-icon-container i-filter-container",
    icon: "i-more-menu-icon",
    spaceFilters: "i-space-filter",
    button: "i-book-button",
    dateString: "i-date-string",
    bookingConfirmedBody: "i-booking-confirmed-body"
  };

export default class BookingConfirmed extends React.Component {
    bookingSystemType = getBookingSystemType();

    constructor(props) {
        super(props);
        this.state = {
            popoverOpen: false
        };
    }

    // addToCalendarClicked = () => {
    //     const { data } = this.props;
    //     const reservation = data && data.reservation;
    //     const params = data && data.params;
    //     downloadICSFile(reservation, params);
    // }

    _togglePopover = () => {
        this.setState({ popoverOpen: !this.state.popoverOpen });
    }

    renderCalendarButton() {
        if (this.bookingSystemType === "office365") {
            return null;
        }

        const { data, unit } = this.props;
        const reservation = data && data.reservation;
        const { popoverOpen } = this.state;
        const i18n = Context.instance.i18n;
        const calendarButton = (
            <Button onClick={this._togglePopover}>
                {i18n.events.details.addToCalendar}
            </Button>
        );

        const reservationsDataset = Context.getInstance().aiim.datasets.reservations;
        const unitsDataset = Context.getInstance().aiim.datasets.units;
        const calendarParams = makeEventInfo(reservationsDataset, reservation, unitsDataset, unit);

        return (
            <CalendarSelector 
                onRequestClose={this._togglePopover}
                open={popoverOpen}
                targetEl={calendarButton}
                params={calendarParams}
            />
        );
    }

    render(){
        const i18n = Context.instance.i18n;
        let title = i18n.more.bookWorkspace.bookingDetailsTitle;
        title = title.replace("{levelName}", this.props.levelName);
        title = title.replace("{buildingName}", this.props.facilityName);

        const requestHeader =
            this.bookingSystemType === "office365"
                ? i18n.more.bookWorkspace.bookingRequested
                : this.bookingSystemType === "esri"
                ? i18n.more.bookWorkspace.bookingConfirmed
                : null;
        let requestInfo =
            this.bookingSystemType === "office365"
                ? i18n.more.bookWorkspace.bookingRequestedInfo
                : this.bookingSystemType === "esri"
                ? i18n.more.bookWorkspace.bookingRequestApproved
                : null;
        requestInfo = requestInfo.replace("{unit}", this.props.unitName);


        return(
        <div className={CSS.popoutOuter}>
            <div className={CSS.popoutInner}>
                <div className={CSS.panelHeader}>
                <div className={CSS.bookingDetailsTitle}>
                    <h2>{this.props.unitName}</h2>
                    <h4>{title}</h4>
                </div>
                <div className={CSS.panelHeaderTools}>
                    <button ref={this.closeRef}
                    title={i18n.general.close} aria-label={i18n.infoPanel.closeAriaLabel}
                    tabIndex="0" onClick={this.props.closePopup}>
                    {Icons.close()}
                    </button>
                </div>
                </div>
                <div className={CSS.bookingConfirmedBody}>
                    <CheckCircleIcon color="green"/>
                    <h1>{requestHeader}</h1>
                    <h2>{requestInfo}</h2>
                    {this.renderCalendarButton()}
                </div>
        </div>
        </div>
        );
    }
} 